import * as React from 'react';
import Heading from '~/UI/Heading';

import { CheckboxRow } from './CheckboxRow';
import styles from './styles.less';
import { TextAreaRow } from './TextAreaRow';

export interface AnnexForm1Values {
	readonly address: string;
	readonly companyName: string;
	readonly contactPersonName: string;
	readonly email: string;
	readonly phone: string;
	readonly representativeName: string;
	readonly signedName: string;
}

export const AnnexForm1: React.FunctionComponent<
	React.PropsWithChildren<{
		disabled: boolean;
		values: AnnexForm1Values;
		onChange(values: AnnexForm1Values): void;
	}>
> = ({ disabled, values, onChange }) => {
	return (
		<div className={styles.profileSection}>
			<Heading level={2}>Export Annex 1</Heading>

			<TextAreaRow
				small
				disabled={disabled}
				value={values.representativeName}
				onChange={(value) => {
					onChange({ ...values, representativeName: value });
				}}
			>
				Application Submitted by Representative – Name:
			</TextAreaRow>

			<TextAreaRow
				small
				disabled={disabled}
				value={values.companyName}
				onChange={(value) => {
					onChange({ ...values, companyName: value });
				}}
			>
				Company Name
			</TextAreaRow>

			<TextAreaRow
				small
				disabled={disabled}
				value={values.address}
				onChange={(value) => {
					onChange({ ...values, address: value });
				}}
			>
				Address
			</TextAreaRow>

			<TextAreaRow
				small
				disabled={disabled}
				value={values.phone}
				onChange={(value) => {
					onChange({ ...values, phone: value });
				}}
			>
				Phone
			</TextAreaRow>

			<TextAreaRow
				small
				disabled={disabled}
				value={values.email}
				onChange={(value) => {
					onChange({ ...values, email: value });
				}}
			>
				Email
			</TextAreaRow>

			<TextAreaRow
				small
				disabled={disabled}
				value={values.contactPersonName}
				onChange={(value) => {
					onChange({ ...values, contactPersonName: value });
				}}
			>
				Contact Person Name
			</TextAreaRow>

			<TextAreaRow
				small
				disabled={disabled}
				value={values.signedName}
				onChange={(value) => {
					onChange({ ...values, signedName: value });
				}}
			>
				Signed Name
			</TextAreaRow>
		</div>
	);
};

AnnexForm1.displayName = 'RoMaxPrice.UserSettings.AnnexForm1';
